import { Icon, RelativeDateTime, SupportedIcon } from 'corso-admin-ui';
import { NavLink } from 'react-router-dom';

export function QuickSearchListItem({
  to,
  externalId,
  customerName,
  createdOn,
  source,
  icon,
  storeName,
}: {
  // without a destination the item is only selected, not navigated to
  to?: string;
  externalId: string;
  customerName: string | null;
  createdOn: string;
  // shown in place of the created date for entities where origin matters more than age
  source?: string | null;
  icon: SupportedIcon;
  // only a concierge sees results from more than one store, so only they need the name
  storeName?: string | null;
}) {
  const content = (
    <>
      <Icon icon={icon} className="text-neutral-700" />
      <div>
        {storeName && <p className="text-xs font-medium">{storeName}</p>}
        <p className="text-xs">{externalId}</p>
        {customerName && <p className="text-xs">{customerName}</p>}
        <p className="text-xs">
          {source ?? (
            <>
              Created <RelativeDateTime dateTime={createdOn} />
            </>
          )}
        </p>
      </div>
    </>
  );

  return to ? (
    <NavLink to={to} className="flex w-full items-center gap-4 px-2">
      {content}
    </NavLink>
  ) : (
    <div className="flex w-full items-center gap-4 px-2">{content}</div>
  );
}
